module.exports = __webpack_public_path__ + "static/media/law-combined.f2d45974.jpg";